(function () {
  if (window._muskThumbSync) return;
  window._muskThumbSync = true;

  // ── Mobile: label thumbnails (.m-thumb-strip__thumb) ─────────────────────────

  document.addEventListener('click', function (e) {
    var lbl = e.target.closest ? e.target.closest('.m-thumb-strip__thumb') : null;
    if (!lbl) return;
    var list = lbl.closest('.m-thumb-strip__list');
    if (!list) return;
    list.querySelectorAll('.m-thumb-strip__thumb').forEach(function (el) {
      el.classList.toggle('swiper-slide-thumb-active', el === lbl);
    });
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target || e.target.type !== 'radio' || !e.target.id) return;
    var radioId = e.target.id;
    document.querySelectorAll('.m-thumb-strip__thumb').forEach(function (lbl) {
      if (lbl.getAttribute('for') !== radioId) return;
      var list = lbl.closest('.m-thumb-strip__list');
      if (!list) return;
      list.querySelectorAll('.m-thumb-strip__thumb').forEach(function (el) {
        el.classList.toggle('swiper-slide-thumb-active', el === lbl);
      });
    });
  });

  // ── SlideChange → radio click (swipe syncs variant) ──────────────────────────

  function attachSlideSync(gallery) {
    if (gallery._slideSync) return;
    gallery._slideSync = true;

    var poll = setInterval(function () {
      if (!gallery.slider || !gallery.productData) return;
      clearInterval(poll);

      var variants = gallery.productData.variants;
      if (!variants) return;

      var container =
        gallery.closest('[data-section-type="product-page"]') ||
        gallery.closest('[data-section-id]') ||
        gallery.closest('.m-main-product');
      if (!container) return;

      var syncing = false;
      gallery.slider.on('slideChange', function () {
        if (syncing) return;
        var sw = gallery.slider;

        // Use realIndex + original (non-clone) slides to avoid loop-clone confusion.
        // During a Swiper loop transition activeIndex may point to a duplicate slide.
        var origSlides = Array.from(sw.slides).filter(function (s) {
          return !s.classList.contains('swiper-slide-duplicate');
        });
        var active = origSlides[sw.realIndex] || sw.slides[sw.activeIndex];
        if (!active) return;

        var mediaId = parseInt(active.dataset.mediaId, 10);
        if (!mediaId || isNaN(mediaId)) return;

        var variant = variants.find(function (v) {
          return v.featured_media && parseInt(v.featured_media.id, 10) === mediaId;
        });
        if (!variant) return;

        var val = variant.options[0];
        if (!val) return;

        // ── Radio button picker (color / image / button types) ────────────────
        var radio = container.querySelector(
          '[data-picker-field] input[type="radio"][value="' +
          val.replace(/["\\]/g, '\\$&') + '"]'
        );
        if (radio) {
          if (radio.checked) return;
          // Defer to next tick so Swiper can finish its own loop-snap first.
          // Without this, our slideToLoop() call (via setActiveMedia inside the
          // variant picker) can race with Swiper's internal loopFix and leave
          // activeIndex pointing at the wrong slide on the next slideChange.
          syncing = true;
          setTimeout(function () {
            try { if (!radio.checked) radio.click(); } catch (e) {}
            syncing = false;
          }, 0);
          return;
        }

        // ── Fallback: select / dropdown picker type ───────────────────────────
        var selEl = container.querySelector('[data-picker-field="select"] select');
        if (!selEl || selEl.value === val) return;

        syncing = true;
        setTimeout(function () {
          try {
            if (selEl.value !== val) {
              selEl.value = val;
              selEl.dispatchEvent(new Event('change', { bubbles: true }));
              var thumbList = container.querySelector('.m-thumb-strip__list');
              if (thumbList) {
                thumbList.querySelectorAll('.m-thumb-strip__thumb').forEach(function (lbl) {
                  lbl.classList.toggle('swiper-slide-thumb-active',
                    lbl.getAttribute('data-variant-value') === val);
                });
              }
            }
          } catch (e) {}
          syncing = false;
        }, 0);
      });
    }, 50);
  }

  function initMobile() {
    document.querySelectorAll('media-gallery-mobile').forEach(attachSlideSync);
  }

  function initQuickview() {
    document.querySelectorAll('media-gallery').forEach(attachSlideSync);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.querySelectorAll) {
            node.querySelectorAll('media-gallery').forEach(attachSlideSync);
          }
          if (node.matches && node.matches('media-gallery')) {
            attachSlideSync(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Quickview: show/hide the sample/decant note based on the selected
  //    variant: se muestra SOLO en los tamaños de muestra (3/5/8/10 ml) y
  //    nunca si la variante está marcada como "is_fullbottle". El inline
  //    <script> de product-option.liquid nunca corre acá porque el HTML
  //    llega vía appendChild ────────────────────────────────────────────

  var SAMPLE_SIZES = ['3ml', '5ml', '8ml', '10ml'];

  function isSampleSize(value) {
    var v = (value || '').toLowerCase().replace(/\s+/g, '');
    for (var i = 0; i < SAMPLE_SIZES.length; i++) {
      if (v.indexOf(SAMPLE_SIZES[i]) !== -1) return true;
    }
    return false;
  }

  function checkSampleNote(picker) {
    var container = picker.closest('.m-product-quickview') || picker.parentElement;
    if (!container) return;
    var notes = container.querySelectorAll('.variant-ml-note');
    if (!notes.length) return;

    var isFullbottle = false;
    var isSample = false;
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
      var node = radio.closest('.m-product-option--node');
      if (node && node.getAttribute('data-is-fullbottle') === 'true') isFullbottle = true;
      if (node && (node.getAttribute('data-value') || '').toLowerCase().indexOf('retail bottle') !== -1) isFullbottle = true;
      if (isSampleSize(radio.value)) isSample = true;
    });
    picker.querySelectorAll('select').forEach(function (select) {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      if (opt.getAttribute('data-is-fullbottle') === 'true') isFullbottle = true;
      if ((opt.value || '').toLowerCase().indexOf('retail bottle') !== -1) isFullbottle = true;
      if (isSampleSize(opt.value)) isSample = true;
    });

    var show = isSample && !isFullbottle;
    notes.forEach(function (note) {
      note.style.display = show ? 'block' : 'none';
    });
  }

  function attachSampleNoteSync(picker) {
    if (picker._sampleNoteSync) return;
    picker._sampleNoteSync = true;
    picker.addEventListener('change', function (e) {
      if (e.target.type === 'radio' || e.target.tagName === 'SELECT') checkSampleNote(picker);
    });
    checkSampleNote(picker);
  }

  function initQuickviewSampleNote() {
    document.querySelectorAll('.m-product-quickview [data-variant-picker]').forEach(attachSampleNoteSync);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.querySelectorAll) {
            node.querySelectorAll('.m-product-quickview [data-variant-picker]').forEach(attachSampleNoteSync);
          }
          if (node.matches && node.matches('[data-variant-picker]') && node.closest('.m-product-quickview')) {
            attachSampleNoteSync(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMobile();
      initQuickview();
      initQuickviewSampleNote();
    });
  } else {
    initMobile();
    initQuickview();
    initQuickviewSampleNote();
  }

})();
